import { render, staticRenderFns } from "./LockoutSession.vue?vue&type=template&id=639b096a&scoped=true"
import script from "./LockoutSession.vue?vue&type=script&lang=js"
export * from "./LockoutSession.vue?vue&type=script&lang=js"
import style0 from "./LockoutSession.vue?vue&type=style&index=0&id=639b096a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b096a",
  null
  
)

export default component.exports